import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryMoveGoodToBadPostBody, IInventoryMoveGoodToBadResponse } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useProductMoveGoodToBadAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [status, setStatus] = useState<boolean>();
  const { disable, enable } = useLoaderActions("isInventoryProductMoveGoodToBadInProgress");

  const execute = useCallback(
    async (productGoodToBadData: IInventoryMoveGoodToBadPostBody, setInvisible) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!productGoodToBadData) {
          return;
        }
        await axios
          .post(`${INVENTORY_MODULE?.MOVE_GOOD_TO_BAD?.baseURL}`, JSON.stringify(productGoodToBadData), {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryMoveGoodToBadResponse>) => {
            disable();
            if (res.data.status === true) {
              toast.success(`Moved to Bad`);
              setInvisible();
              setStatus(true);
            } else {
              toast.error("Cannot move to bad.");
              setStatus(false);
            }
          })
          .catch((e: AxiosError) => {
            disable();
            sendCurl(e.config?.["curlCommand"]);
            setInvisible();
            if (e.response && e.response.status === 400) {
              const errorMessage =
                (e.response.data as { message?: string })?.message || "Bad Request: Unable to move to bad.";
              toast.error(errorMessage);
            } else {
              toast.error("An unexpected error occurred.");
            }
          });
      } catch (error) {
        disable();
        setInvisible();
        // Handle errors
        setStatus(false);
        if (axios.isAxiosError(error)) {
          captureError(error);
          const errorMessage =
            (error.response?.data as { message?: string })?.message || "API Error: Unable to process request.";
          toast.error(errorMessage);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { execute, status };
};
